module.exports = "https://coursera_assets.s3.amazonaws.com/images/3af99899466b568452f158df6358ff63.png";